import { render, staticRenderFns } from "./DetailQuickView.vue?vue&type=template&id=d58e3882"
import script from "./DetailQuickView.vue?vue&type=script&lang=js"
export * from "./DetailQuickView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports